import React, { useState } from 'react'

const TabsCard = ({
    blogTypeData = [
        {
            blog_type_id: 1,
            frontend_component_blog_type_id: 1,
            blog_type_name: "測試分類",
            frontend_column_frontend_component_blog_type_blog_data: [
                {
                    "blog_type_blog_id": 1,
                    "blog_id": 100,
                    "title": "文章標題",
                    "content": "文章內容1",
                    "annoucement_time": "2023-06-05T18:39:53.187227+08:00",
                    "top": null,
                    "top_edit_time": null,
                    "blog_index": null,
                    "more_content": null,
                    "show": null,
                    "external_link": null,
                    "youtube_iframe": null,
                    "youtube_thumbnail": null,
                    "property_json": null,
                    "extermal_link_check": null,
                    "blog_type_classify_structure_type_blog_data": [
                        {
                            "classify_structure_type_blog_id": 12,
                            "classify_structure_type_id": 1876,
                            "file_id": null,
                            "file_client_name": "LINE_ALBUM_環境_230205_53.jp",
                            "upload_time": "2023-05-10",
                            "upload_user_name": "測試人員QB006",
                            "last_edit_time": "2023-05-10",
                            "last_edit_user_name": null
                        }
                    ]
                },
                {
                    "blog_type_blog_id": 1,
                    "blog_id": 100,
                    "title": "文章標題",
                    "content": "文章內容1",
                    "annoucement_time": "2023-06-05T18:39:53.187227+08:00",
                    "top": null,
                    "top_edit_time": null,
                    "blog_index": null,
                    "more_content": null,
                    "show": null,
                    "external_link": null,
                    "youtube_iframe": null,
                    "youtube_thumbnail": null,
                    "property_json": null,
                    "extermal_link_check": null,
                    "blog_type_classify_structure_type_blog_data": [
                        {
                            "classify_structure_type_blog_id": 12,
                            "classify_structure_type_id": 1876,
                            "file_id": null,
                            "file_client_name": "LINE_ALBUM_環境_230205_53.jp",
                            "upload_time": "2023-05-10",
                            "upload_user_name": "測試人員QB006",
                            "last_edit_time": "2023-05-10",
                            "last_edit_user_name": null
                        }
                    ]
                },
                {
                    "blog_type_blog_id": 1,
                    "blog_id": 100,
                    "title": "文章標題",
                    "content": "文章內容1",
                    "annoucement_time": "2023-06-05T18:39:53.187227+08:00",
                    "top": null,
                    "top_edit_time": null,
                    "blog_index": null,
                    "more_content": null,
                    "show": null,
                    "external_link": null,
                    "youtube_iframe": null,
                    "youtube_thumbnail": null,
                    "property_json": null,
                    "extermal_link_check": null,
                    "blog_type_classify_structure_type_blog_data": [
                        {
                            "classify_structure_type_blog_id": 12,
                            "classify_structure_type_id": 1876,
                            "file_id": null,
                            "file_client_name": "LINE_ALBUM_環境_230205_53.jp",
                            "upload_time": "2023-05-10",
                            "upload_user_name": "測試人員QB006",
                            "last_edit_time": "2023-05-10",
                            "last_edit_user_name": null
                        }
                    ]
                },
                {
                    "blog_type_blog_id": 1,
                    "blog_id": 100,
                    "title": "文章標題",
                    "content": "文章內容1",
                    "annoucement_time": "2023-06-05T18:39:53.187227+08:00",
                    "top": null,
                    "top_edit_time": null,
                    "blog_index": null,
                    "more_content": null,
                    "show": null,
                    "external_link": null,
                    "youtube_iframe": null,
                    "youtube_thumbnail": null,
                    "property_json": null,
                    "extermal_link_check": null,
                    "blog_type_classify_structure_type_blog_data": [
                        {
                            "classify_structure_type_blog_id": 12,
                            "classify_structure_type_id": 1876,
                            "file_id": null,
                            "file_client_name": "LINE_ALBUM_環境_230205_53.jp",
                            "upload_time": "2023-05-10",
                            "upload_user_name": "測試人員QB006",
                            "last_edit_time": "2023-05-10",
                            "last_edit_user_name": null
                        }
                    ]
                },

            ]
        },
        {
            blog_type_id: 1,
            frontend_component_blog_type_id: 1,
            blog_type_name: "科技新聞",
            frontend_column_frontend_component_blog_type_blog_data: [
                {
                    blog_type_blog_id: 1,
                    blog_id: 101,
                    title: "人工智慧的未來",
                    content: "人工智慧正在改變世界的方方面面，從醫療到交通。",
                    annoucement_time: "2023-10-01T10:00:00+08:00",
                    top: null,
                    top_edit_time: null,
                    blog_index: null,
                    more_content: null,
                    show: true,
                    external_link: null,
                    youtube_iframe: null,
                    youtube_thumbnail: null,
                    property_json: null,
                    extermal_link_check: null,
                    blog_type_classify_structure_type_blog_data: []
                },
                {
                    blog_type_blog_id: 2,
                    blog_id: 102,
                    title: "區塊鏈技術的應用",
                    content: "區塊鏈不僅僅是比特幣，還有更多的應用場景。",
                    annoucement_time: "2023-10-05T14:30:00+08:00",
                    top: null,
                    top_edit_time: null,
                    blog_index: null,
                    more_content: null,
                    show: true,
                    external_link: null,
                    youtube_iframe: null,
                    youtube_thumbnail: null,
                    property_json: null,
                    extermal_link_check: null,
                    blog_type_classify_structure_type_blog_data: []
                },
                {
                    blog_type_blog_id: 3,
                    blog_id: 103,
                    title: "5G時代的到來",
                    content: "5G網絡將帶來更快的速度和更多的可能性。",
                    annoucement_time: "2023-10-10T09:15:00+08:00",
                    top: null,
                    top_edit_time: null,
                    blog_index: null,
                    more_content: null,
                    show: true,
                    external_link: null,
                    youtube_iframe: null,
                    youtube_thumbnail: null,
                    property_json: null,
                    extermal_link_check: null,
                    blog_type_classify_structure_type_blog_data: []
                },
                {
                    blog_type_blog_id: 4,
                    blog_id: 104,
                    title: "雲計算的優勢",
                    content: "雲計算讓企業可以更加靈活地管理資源。",
                    annoucement_time: "2023-10-15T16:45:00+08:00",
                    top: null,
                    top_edit_time: null,
                    blog_index: null,
                    more_content: null,
                    show: true,
                    external_link: null,
                    youtube_iframe: null,
                    youtube_thumbnail: null,
                    property_json: null,
                    extermal_link_check: null,
                    blog_type_classify_structure_type_blog_data: []
                }
            ]
        }
    ]
}) => {
    
    const TabsCardComponent = ({ TabsData = {} }) => {
        const [TabsStatus, setTabsStatus] = useState(0);

        const renderTabsContent = () => {
            const currentTab = TabsData?.frontend_column_frontend_component_blog_type_blog_data?.find(
                (data, i) => i === TabsStatus
            );
            return currentTab ? (
                <div>
                    <h3 className="text-lg font-bold">{currentTab.title}</h3>
                    <p>{currentTab.content}</p>
                </div>
            ) : null;
        };

        return (
            <div className="w-full rounded shadow-lg bg-transparent mb-4">
                <div className="flex">
                    {TabsData?.frontend_column_frontend_component_blog_type_blog_data?.map(
                        (Tabas, i) => (
                            <div
                                key={i}
                                className="flex-1 min-w-0 cursor-pointer"
                            >
                                <h2
                                    onClick={() => setTabsStatus(i)}
                                    className={`text-center p-2 rounded-t font-bold transition-all duration-300 truncate ${TabsStatus === i
                                        ? 'bg-white text-neutral-900'
                                        : 'text-gray-600 hover:text-gray-900 hover:bg-white hover:opacity-100 opacity-75'
                                        }`}
                                >
                                    {Tabas?.title}
                                </h2>
                            </div>
                        )
                    )}
                </div>
                <div className="bg-white rounded-b">
                    <div className="text-center p-2 sm:p-4 md:p-6 lg:p-8 xl:p-8">
                        {renderTabsContent()}
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            {blogTypeData.map((TabsData, TabsDataIndex) => (
                <TabsCardComponent key={TabsDataIndex} TabsData={TabsData} />
            ))}
        </>

    );
}



export default TabsCard